// extracted by mini-css-extract-plugin
export default {"view":"Layout_view__N2ph5","myPage":"Layout_myPage__SwZ8U"};